import { combineReducers } from 'redux';

import adminImportReducer from '../adminImportPage/store/reducer';
import beginningBalancesReducer from '../beginningBalancesPage/store/reducer';
import businessUnitSettingsReducer from '../businessUnitSettingsPage/store/reducer';
import glAccountListReducer from '../GLAccountListPage/store/reducer';
import accountMapReducer from '../accountMapPage/store/reducer';
import taxAccountingSettingsReducer from '../taxAccountingSettingsPage/store/reducer';
import tlsAccountSettingsReducer from '../tlsAccountSettingsPage/store/reducer';
import legalEntitySettingsReducer from '../legalEntitySettingsPage/store/reducer';
import obligationsPageReducer from '../obligationsPage/store/reducer';
import taxBookingEntitiesReducer from '../taxBookingEntitiesPage/store/reducer';
import taxRatesReducer from '../taxRatesPage/store/reducer';
import slAccountsReducer from '../slAccountsPage/store/reducer';
import companyCodesReducer from '../companyCodesPage/store/reducer';
import glJournalsReducer from '../glJournalsPage/store/reducer';
import adminTaxEntrySettingsReducer from '../adminTaxEntrySettingsPage/store/reducer';
import chartOfAccountsReducer from '../chartOfAccountsPage/store/reducer';
import categoriesAndTagsReducer from '../categoriesAndTagsPage/store/reducer';
import CurrencyConversionRatesReducer from '../currencyConversionRatesPage/store/reducer';
import customGroupsReducer from '../customGroupsPage/store/reducer';
import applicationSettingsReducer from '../applicationSettings/store/reducer';
import customReportsReducer from '../customReportsManagementPage/store/reducer';
import trialBalanceThreshold from '../trialBalanceThresholdPage/store/reducer';
import bookToTaxDifferencesReducer from '../bookToTaxDifferencesPage/store/reducer';
import databaseLogsReducer from '../databaseLogsPage/store/reducer';
import e2eHealthcheckReducer from '../e2eHealthcheckPage/store/reducer';

import getAdminReducer from '../shared/store/reducerFactory';
import { adminPageNames } from '../shared/adminPageNames';

export default combineReducers({
  adminImport: adminImportReducer,
  beginningBalances: beginningBalancesReducer,
  businessUnitSettings: businessUnitSettingsReducer,
  [adminPageNames.GL_ACCOUNT_LIST]: getAdminReducer(
    adminPageNames.GL_ACCOUNT_LIST,
    { customReducer: glAccountListReducer }
  ),
  [adminPageNames.ACCOUNT_MAP]: getAdminReducer(
    adminPageNames.ACCOUNT_MAP,
    { customReducer: accountMapReducer }
  ),
  [adminPageNames.TAX_ACCOUNTING]: getAdminReducer(adminPageNames.TAX_ACCOUNTING, {
    customReducer: taxAccountingSettingsReducer,
  }),
  [adminPageNames.TLS_ACCOUNTS]: getAdminReducer(adminPageNames.TLS_ACCOUNTS, {
    customReducer: tlsAccountSettingsReducer,
  }),
  [adminPageNames.TAX_BOOKING_ENTITIES]: getAdminReducer(adminPageNames.TAX_BOOKING_ENTITIES, {
    customReducer: taxBookingEntitiesReducer,
  }),
  [adminPageNames.LEGAL_ENTITIES]: getAdminReducer(adminPageNames.LEGAL_ENTITIES, {
    customReducer: legalEntitySettingsReducer,
  }),
  [adminPageNames.TAX_RATES]: getAdminReducer(adminPageNames.TAX_RATES, {
    customReducer: taxRatesReducer,
  }),
  [adminPageNames.SL_ACCOUNTS]: getAdminReducer(adminPageNames.SL_ACCOUNTS, { customReducer: slAccountsReducer }),
  [adminPageNames.COMPANY_CODES]: getAdminReducer(adminPageNames.COMPANY_CODES, { customReducer: companyCodesReducer }),
  [adminPageNames.GL_JOURNALS]: getAdminReducer(adminPageNames.GL_JOURNALS, { customReducer: glJournalsReducer }),
  bookToTaxDifferences: bookToTaxDifferencesReducer,
  [adminPageNames.BOOK_TO_TAX_CODE_DESCRIPTIONS]: getAdminReducer(adminPageNames.BOOK_TO_TAX_CODE_DESCRIPTIONS),
  [adminPageNames.CLIENTS]: getAdminReducer(adminPageNames.CLIENTS),
  [adminPageNames.ADMIN_TAX_ENTRY_SETTINGS]: getAdminReducer(adminPageNames.ADMIN_TAX_ENTRY_SETTINGS, {
    customReducer: adminTaxEntrySettingsReducer,
  }),
  [adminPageNames.COMMUNICATIONS_MANAGEMENT]: getAdminReducer(adminPageNames.COMMUNICATIONS_MANAGEMENT),
  chartOfAccounts: chartOfAccountsReducer,
  categoriesAndTags: categoriesAndTagsReducer,
  customReports: customReportsReducer,
  currencyConversionRates: CurrencyConversionRatesReducer,
  customGroups: customGroupsReducer,
  applicationSettings: applicationSettingsReducer,
  obligations: obligationsPageReducer,
  [adminPageNames.TRIAL_BALANCE_THRESHOLD]: getAdminReducer(adminPageNames.TRIAL_BALANCE_THRESHOLD, {
    customReducer: trialBalanceThreshold,
  }),
  databaseLogs: databaseLogsReducer,
  e2eHealthcheck: e2eHealthcheckReducer,
});
